"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useModal = function () {
    var _a = react_1.useState(false), isModalOpen = _a[0], setIsModalOpen = _a[1];
    function closeModal() {
        setIsModalOpen(false);
    }
    function openModal() {
        setIsModalOpen(true);
    }
    return {
        isModalOpen: isModalOpen,
        openModal: openModal,
        closeModal: closeModal,
    };
};
exports.default = useModal;
//# sourceMappingURL=useModal.js.map